<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-10">
          <v-card-actions>
            <v-row>
              <v-col
                cols="4"
              >
                <v-text-field
                  v-model="search"
                  placeholder="Key in notification name here"
                  append-icon="search"
                  label="Search notification type"
                  hide-no-data
                  hide-selected
                  clearable 
                />
              </v-col>
            </v-row>
          </v-card-actions>
          
          <v-data-table
            :headers="headers"
            :items="filteredNotificationTypes"
            :loading="tableLoading"
            :search="search"
          >
            <template v-slot:item.name="{ item }">
              <div>
                <span>
                  {{ item.name }}
                </span>
              </div>
            </template>
            <template v-slot:item.is_active="{ item }">
              <div>
                <v-icon 
                  v-if="item.is_active === 1" 
                  color="success"
                >
                  mdi-check-outline
                </v-icon>
                <v-icon 
                  v-else 
                  color="error"
                >
                  mdi-close-outline
                </v-icon>
              </div>
            </template>

            <!-- <template v-slot:item.action="{ item }">
              <setup-notifications-dialog-edit
                :notification-type="item"
                @updated="loadData"
              />
            </template> -->
          </v-data-table>
        </v-card> 
      </v-col>
    </v-row>    
  </v-container>
</template>

<script>
  export default {
    components: {
    //   SetupNotificationsDialogEdit: () => import('@/components/setup/notifications/DialogEdit'),
    },
    metaInfo () {
      return {
        title: 'Notification Types',
      }
    },
    data () {
      return {
        notificationTypes: [],
        trashedNotificationTypes: [],
        headers: [
          {
            text: 'Notification Types',
            align: 'left',
            value: 'name',
          },
          {
            text: 'Active',
            align: 'left',
            value: 'is_active',
          },
        //   {
        //     text: 'Actions',
        //     sortable: false,
        //     value: 'action',
        //   },
        ],

        search: '',
        statusFilter: { state: 'Active', value: true },
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
        tableLoading: true,
      }
    },
    computed: {
      filteredNotificationTypes () {
        return this.statusFilter ? this.notificationTypes : this.trashedNotificationTypes
      },
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        this.loadNotificationTypes()
        this.loadTrashedNotificationTypes()
      },
      loadNotificationTypes () {
        this.$api.notificationTypes().list()
          .then(response => {
            this.notificationTypes = response.data
            this.tableLoading = false
          })
      },
      loadTrashedNotificationTypes () {
        this.$api.notificationTypes().listTrashed()
          .then(response => {
            this.trashedNotificationTypes = response.data
          })
      },
    },
  }
</script>
